import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus-bold",
  "use": "icon-plus-bold-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-plus-bold\">\n<path d=\"M170,90H110V30c0-5.5-4.4-10-10-10c-5.5,0-10,4.4-10,10V90H30c-5.5,0-10,4.4-10,10c0,5.5,4.4,10,10,10H90V170\n\tc0,5.5,4.4,10,10,10c5.5,0,10-4.4,10-10V110H170c5.5,0,10-4.4,10-10C180.1,94.5,175.6,90,170,90L170,90z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol